export enum QueryKey {
  auth = "auth",
  enemies = "enemies",
  keys = "keys",
  locations = "locations",
  keygivers = "keygivers",
  keygiverdrops = "keygiverdrops",
  lastkeygiverdrops = "lastkeygiverdrops",
  editablekeygiverdrops = "editablekeygiverdrops",
  keyGiverDropsStats = "keyGiverDropsStats",
  items = "items",
  magicItems = "magicItems",
  privileges = "privileges",
  settings = "settings",
  backups = "backups",
}
